export class LabResults {

	ResultName: string;

	ObservedValue: string;

	RefRange: string;

    AbnormalFlag: string;
    Units: string;
    TESTCOMMENTS: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/lab/LabResults.ts